import React, { useMemo } from "react";
import {
  Text,
  Img,
  SimpleGrid,
  VStack,
  Flex,
  Box,
  Divider,
  Heading,
  ChakraProps,
} from "@ssg-ui/react";
import { chunk } from "lodash";

interface Props extends ChakraProps {
  data?: { imageUrl: string; imageAlt: string; text: string }[];
  title?: string;
  columns: number;
}

export const RowDividerThumbnailList = (props: Props) => {
  const { data, title, columns, ...rest } = props;
  const chunks = useMemo(() => chunk(data, columns), [data, columns]);

  return (
    <Box w="full" {...rest}>
      {title && (
        <Box mb={4}>
          <Heading as="h3" fontSize="2xl">
            {title}
          </Heading>
        </Box>
      )}
      <VStack divider={<Divider />} align="stretch">
        {chunks?.map((chunk, rowIndex) => {
          return (
            <SimpleGrid columns={columns} key={rowIndex}>
              {chunk?.map((item) => (
                <Flex direction="column" key={item.text} py="2">
                  <Box position="relative" h="0" pb="100%">
                    <Img
                      position="absolute"
                      top="0"
                      left="0"
                      w="full"
                      h="full"
                      src={item.imageUrl}
                      alt={item.imageAlt}
                    />
                  </Box>
                  <Text textAlign="center" fontSize="11px" mt="2">
                    {item.text}
                  </Text>
                </Flex>
              ))}
            </SimpleGrid>
          );
        })}
      </VStack>
    </Box>
  );
};

RowDividerThumbnailList.defaultProps = {
  title: "타이틀",
  columns: 4,
  data: [
    {
      imageUrl:
        "https://simg.ssgcdn.com/trans.ssg?src=/cmpt/banner/202007/2020072114390815774221130522_275.jpg&w=150&h=150&edit=c&t=3b7a7a1a59ad1acd58275c3d37b6417d4226f74f",
      imageAlt: "패션 카테고리 썸네일",
      text: "패션",
    },
    {
      imageUrl:
        "https://simg.ssgcdn.com/trans.ssg?src=/cmpt/banner/202007/2020072114393459688641690964_438.jpg&w=150&h=150&edit=c&t=157f383ac7347381b9e7fbe2cc0e7025f3a50036",
      imageAlt: "잡화 카테고리 썸네일",
      text: "잡화",
    },
    {
      imageUrl:
        "https://simg.ssgcdn.com/trans.ssg?src=/cmpt/banner/202007/2020072814443183038628520962_559.jpg&w=150&h=150&edit=c&t=4547096e3f0cad6929e665a84404e45df519057b",
      imageAlt: "뷰티X먼데이문 카테고리 썸네일",
      text: "뷰티X먼데이문",
    },
    {
      imageUrl:
        "https://simg.ssgcdn.com/trans.ssg?src=/cmpt/banner/202007/2020072114401652224140854414_993.jpg&w=150&h=150&edit=c&t=7f03a61610f0ec4cf6dbc3418d0292b8e09ea4f4",
      imageAlt: "스포츠 카테고리 썸네일",
      text: "스포츠",
    },
    {
      imageUrl:
        "https://simg.ssgcdn.com/trans.ssg?src=/cmpt/banner/202007/2020072114401652224140854414_993.jpg&w=150&h=150&edit=c&t=7f03a61610f0ec4cf6dbc3418d0292b8e09ea4f4",
      imageAlt: "생활 카테고리 썸네일",
      text: "생활",
    },
    {
      imageUrl:
        "https://simg.ssgcdn.com/trans.ssg?src=/cmpt/banner/202007/2020072114435685703321603332_446.jpg&w=150&h=150&edit=c&t=b027e6568a78d5992cadfe584b0655d2e93717d3",
      imageAlt: "가구/주방 카테고리 썸네일",
      text: "가구/주방",
    },
    {
      imageUrl:
        "https://simg.ssgcdn.com/trans.ssg?src=/cmpt/banner/202007/2020072114441448481282580228_43.jpg&w=150&h=150&edit=c&t=ebd517b8187aa20287955d94a959857e8be05244",
      imageAlt: "유아동 카테고리 썸네일",
      text: "유아동",
    },
    {
      imageUrl:
        "https://simg.ssgcdn.com/trans.ssg?src=/cmpt/banner/202007/2020072114443838883514790451_300.jpg&w=150&h=150&edit=c&t=81cbadb557356b795a2b3fb88cd7f5f0dcf3ce4e",
      imageAlt: "디지털 카테고리 썸네일",
      text: "디지털",
    },
    {
      imageUrl:
        "https://simg.ssgcdn.com/trans.ssg?src=/cmpt/banner/202007/2020072114450966500216323021_114.jpg&w=150&h=150&edit=c&t=222c54c039fcf3693dcc543288f0c49836490101",
      imageAlt: "도서/e쿠폰/취미 카테고리 썸네일",
      text: "도서/e쿠폰/취미",
    },
    {
      imageUrl:
        "https://simg.ssgcdn.com/trans.ssg?src=/cmpt/banner/202007/2020072114452932964016659401_625.jpg&w=150&h=150&edit=c&t=d47ecbd4e3c5707ad57e2dfa36b2df50115ba168",
      imageAlt: "신선식품 카테고리 썸네일",
      text: "신선식품",
    },
    {
      imageUrl:
        "https://simg.ssgcdn.com/trans.ssg?src=/cmpt/banner/202007/2020072114460463206750262675_650.jpg&w=150&h=150&edit=c&t=f1c090b20c4e287b4a24c395facb38a5ee8cdc9c",
      imageAlt: "가공/건강식품 카테고리 썸네일",
      text: "가공/건강식품",
    },
  ],
};
